import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BackButtonComponent from '../../components/BackButtonComponent/BackButtonComponent';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import {
  CommonFlex,
  CommonGrid,
  Container,
  ContentHeader,
  PageTitle,
} from '../../styledComponents/common';
import TransferringRequestsFilterContainer from './Filter/TransferringRequestsFilterContainer';
import TransferringRequestsList from './TransferringRequestsList';
import { ButtonIcon, WhiteButtonWithIcon } from 'styledComponents/buttons';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';
import excelIcon from '../../assets/img/icons/excel-green.svg';

const TransferringRequests = ({
  getTransferringRequestsList,
  transferringRequestsList,
  isLoading,
  reportLoading,
  sendExportExcelRequest,
}) => {
  const { t } = useTranslation();
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedParams, setSelectedParams] = useState({});

  useEffect(() => {
    getTransferringRequestsList();
  }, []);

  const handleExportToExcel = () => {
    sendExportExcelRequest(selectedParams, 'item-transfers');
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
      <PageTitle>{t('transferring_requests')}</PageTitle>
      <CommonFlex gap="12px">
          {localStorage.getItem('user_role') !== 'employee' ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={reportLoading ? '0 45px' : '0 25px'}
            >
              {reportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex>
      </CommonGrid>
      <TransferringRequestsFilterContainer
        setSelectedParams={setSelectedParams}
        selectedParams={selectedParams}
      />
      <TransferringRequestsList
        isLoading={isLoading}
        transferringRequestsList={transferringRequestsList}
        selectedRequest={selectedRequest}
        selectRequest={setSelectedRequest}
      />
    </div>
  );
};

export default TransferringRequests;
